<template>
    <div class="login_container">
      <Logo />
      <div class="formlogin_container md-elevation-5">
        <h2>Reset Password</h2>
        <div class="form_controller">
            <div class="group_name">
                <input
                    type="password"
                    name="username"
                    class="input_name"
                    placeholder="********"
                    v-model="newpass"
                />
                <div>New password*</div>
            </div>
            <p v-if="newpass && newpassErrors.length" style="color: red;max-width:500px;text-align: left !important;">
                {{ newpassErrors.join(', ') }}
            </p>
            <div class="group_name">
                <input
                    type="password"
                    name="username"
                    class="input_name"
                    placeholder="********"
                    v-model="conpass"
                />
                <div>Confirm new password*</div>
            </div>
          <label style="font-size:12px;margin-bottom:16px;max-width:500px;text-align: left;">
              Password must at least 12 characters, contains at least one of the following: number, symbol, lower letter and upper letter.  
          </label>       
 
          <md-button class="md-raised md-primary btn_login" @click="handleSubmit">Submit</md-button>
          
        </div>
      </div>
      <Footer></Footer>
    </div>
  </template>
  <script>
  import Footer from "../components/Footer";
  import Logo from "@/components/Logo";
import request from "../utils/request";
//   import request from "@/utils/request.js";
//   import tokenUtils from "@/utils/token.js";
  export default {
    name: "ResetPass",
    components: {
      Footer,
      Logo,
    },
    data() {
      return {
        newpass: "",
        conpass:""
      };
    },
    computed:{
        newpassErrors(){
            const errors = [];

            if (this.newpass.length < 12) {
            errors.push("Must be at least 12 characters");
            }
            if (!/[a-z]/.test(this.newpass)) {
            errors.push("Must contain at least one lowercase letter");
            }
            if (!/[A-Z]/.test(this.newpass)) {
            errors.push("Must contain at least one uppercase letter");
            }
            if (!/\d/.test(this.newpass)) {
            errors.push("Must contain at least one digit");
            }
            if (!/[\W_]/.test(this.newpass)) {
            errors.push("Must contain at least one special character.");
            }

            return errors;
        }
    },
    methods: {
      
    handleSubmit(){
        if(this.newpassErrors.length>0){
          return alert("Invalid new password!")
        }
        if(this.newpass!==this.conpass)
        {
          return alert("Comfirm password is not match with new password.Please try again!")
        }
        let resetToken = this.$store.state.resetToken
        if(!resetToken){
            return alert('Invalid token!')
        }
        request('post','/auth/resetpassword',{token:resetToken,newpass:this.newpass})
        .then(data=>{
            if(data.code!=='000'){
                return alert(data.message)
            }
            this.$store.commit('changeResetToken','' )
            alert('Successfully reset your password!')
            
            this.$router.push('/login')
        })
        .catch(()=>{
            alert("Invalid data!")
        })
      }
      
    },
  };
  </script>
  <style lang="scss" scoped>
  .login_container {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    --textColor: #6d6e71;
    position: relative;
    z-index: 1;
  
  }
  .dialog_verify_login{
      .md-dialog-actions{
        .md-button{
          width: 100%;
          margin-left:0px !important;
        }
      }
    }
  .formlogin_container {
    width: 600px;
    
    background-color: white;
    h2 {
      margin-top: 24px;
    }
    .form_controller {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: center;
      align-items: center;
      margin-top: 24px;
  
      .group_name {
        margin-bottom: 17px;
        display: flex;
        flex-direction: column-reverse;
        div {
          text-align: left;
          margin-bottom: 5px;
          color: var(--textColor);
        }
        input {
          width: 500px;
          height: 48px;
          background-color: #ececec;
          border-width: 0px;
          border-radius: 3px;
          padding: 8px;
        }
        input:focus {
          outline: none !important;
          border: 1px solid #0080f6 !important ;
        }
        input:focus + div {
          color: #0080f6;
        }
      }
      .btn_login {
        width: 361px;
        height: 48px;
        font-weight: bold;
        text-transform: none;
        font-size: 1rem;
      }
    }
  }
  </style>
  